module.exports = __webpack_public_path__ + "static/grafika9@2x-eef110d8370345aafe1a5e82c9d1e440.png";